import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import QrCreator from 'qr-creator';
import OkCancelModal from '@/shared/components/OkCancelModal';
import ToastrService from '@/shared/services/ToastrService';
import { useGet2FA } from '@/shared/hooks/profile/useGet2FA';
import { useEnable2FA } from '@/shared/hooks/profile/useEnable2FA';
import messages from '../profileMessages';
const Enable2FAModal = ({ show, onClose, employeeEmail, employeeMobilePhone, }) => {
    const intl = useIntl();
    const { get2FA } = useGet2FA();
    const { enable2FA } = useEnable2FA();
    const qrRef = useRef(null);
    const [secretData, setSecretData] = useState(null);
    const [code, setCode] = useState('');
    const [backupPhone, setBackupPhone] = useState(employeeMobilePhone || '');
    const [dirty, setDirty] = useState(false);
    const showPhoneNumber = !employeeMobilePhone;
    const formValid = code.length > 0;
    useEffect(() => {
        if (!show) {
            setSecretData(null);
            setCode('');
            setBackupPhone(employeeMobilePhone || '');
            setDirty(false);
            return;
        }
        get2FA()
            .then(data => {
            setSecretData(data);
        })
            .catch(() => { });
    }, [show]);
    useEffect(() => {
        if (!secretData || !qrRef.current)
            return;
        qrRef.current.innerHTML = '';
        const appName = `AdminPulse${secretData.environment === 'prd' ? '' : secretData.environment}`;
        const otpUrl = `otpauth://totp/${appName}:${employeeEmail}?secret=${secretData.key}`;
        QrCreator.render({ text: otpUrl, size: 128 }, qrRef.current);
    }, [secretData, employeeEmail]);
    const handleSave = async () => {
        await enable2FA({ code, backupPhone });
        ToastrService.success(intl.formatMessage(messages.TwoFAEnabled));
        onClose();
    };
    return (_jsx(OkCancelModal, Object.assign({ title: intl.formatMessage(messages.Enable2FA), show: show, onSave: handleSave, onClose: onClose, disabled: !formValid, okLabel: intl.formatMessage(messages.Enable2FA), zendeskArticle: "6178142418322" }, { children: _jsxs("div", Object.assign({ className: "form-horizontal" }, { children: [_jsxs("div", Object.assign({ role: "alert", className: "alert alert-info" }, { children: [_jsx("div", { children: intl.formatMessage(messages.Enable2FAInfo) }), _jsxs("div", { children: [_jsx("label", { children: intl.formatMessage(messages.Enable2FAManualKey) }), ' ', _jsx("label", { children: secretData === null || secretData === void 0 ? void 0 : secretData.key })] })] })), _jsx("div", { ref: qrRef, style: {
                        width: '100%',
                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                    } }), _jsxs("div", Object.assign({ className: classNames('form-group margin10T', {
                        'has-error': dirty && !code,
                    }), style: { width: '100%' } }, { children: [_jsx("label", Object.assign({ className: "control-label col-md-3" }, { children: intl.formatMessage(messages.Code) })), _jsxs("div", Object.assign({ className: "col-md-6" }, { children: [_jsx("input", { type: "text", className: "form-control", value: code, onChange: e => {
                                        setCode(e.target.value);
                                        setDirty(true);
                                    } }), dirty && !code && (_jsx("ul", Object.assign({ className: "help-block" }, { children: _jsx("li", { children: intl.formatMessage(messages.FieldRequired) }) })))] }))] })), showPhoneNumber && (_jsxs("div", Object.assign({ className: "form-group margin10T", style: { width: '100%' } }, { children: [_jsx("label", Object.assign({ className: "control-label col-md-3" }, { children: intl.formatMessage(messages.BackupPhone) })), _jsx("div", Object.assign({ className: "col-md-6" }, { children: _jsx("input", { type: "text", className: "form-control", value: backupPhone, onChange: e => setBackupPhone(e.target.value), placeholder: intl.formatMessage(messages.BackupPhone), maxLength: 125 }) }))] })))] })) })));
};
export default Enable2FAModal;
